import { QueryClient, QueryClientProvider } from 'react-query';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import RouterContainer from './router';
import { GlobalStyle, theme } from './styles';
import { persistor, store } from './store';
import { ToastContextProvider } from '@/store/ToastContextProvider';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ToastContextProvider>
            <PersistGate loading={null} persistor={persistor}>
              <HelmetProvider>
                <GlobalStyle />
                <RouterContainer />
              </HelmetProvider>
            </PersistGate>
          </ToastContextProvider>
        </Provider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
